<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar o ajuste de saída de estoque de código <b>{{this.entry.code}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(exitStorageAdjustment) { 
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_EXIT_STORAGE_ADJUSTMENT_MUTATION,
          variables: {
            id: exitStorageAdjustment.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyExitStorageAdjustment.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            // console.log("delete", exitStorageAdjustment);
            this.$emit("entry-destroyed", exitStorageAdjustment);
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_EXIT_STORAGE_ADJUSTMENT_MUTATION = gql `
  mutation($id: ID!) {
    destroyExitStorageAdjustment(id: $id) {
      stockAdjustment {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>